var $ = require('jquery');
$(document).on('mouseover', '.goerwei, .p_showma', function() {
    $('.p_showma').show();
    return false;
}).on('mouseout', '.goerwei, .p_showma', function() {
    $('.p_showma').hide();
    return false;
}).on('mouseenter', '.ic-wxgz,.ic-qqgz', function() {
    $(this).siblings('.p_wxcode').show();
    return false;
}).on('mouseleave', '.ic-wxgz,.ic-qqgz', function() {
    $(this).siblings('.p_wxcode').hide();
    return false;
});



//////////////////
// WEBPACK FOOTER
// ./src/common/foot.js
// module id = 16
// module chunks = 2